// This composable is used to record and access the selection status of options in a single-select selector
import { useStore } from 'vuex';

const useSingleSelector = ({ selection }) => {
  const { commit } = useStore();

  // TODO: This function is provided the keyMap as a second arg, but doesn't use it here. Odd.
  const selectOption = (option) => {
    selection.value = option;
    commit('update', { module: 'selector', key: 'openSelectorId', value: null });
  };

  const isSelected = (option, keyMap) => selection.value?.[keyMap.value] === option[keyMap.value];

  return { selectOption, isSelected };
};

export default useSingleSelector;
